import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { SITE_URL, SITEMAP_LASTMOD } from '../../constants/siteSeo';

export interface HelpStructuredItem {
  name: string;
  description: string;
  url: string;
}

interface HelpPageStructuredDataProps {
  pageUrl: string;
  items: HelpStructuredItem[];
}

/** /help 向け JSON-LD（機能一覧 ItemList + WebPage） */
export default function HelpPageStructuredData({ pageUrl, items }: HelpPageStructuredDataProps) {
  const { t } = useTranslation();
  const description = t('help.meta_description');

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebPage',
        '@id': `${pageUrl}#webpage`,
        url: pageUrl,
        name: t('help.title'),
        description,
        dateModified: SITEMAP_LASTMOD,
        isPartOf: { '@id': `${SITE_URL}/#website` },
        mainEntity: { '@id': `${pageUrl}#tool-list` },
      },
      {
        '@type': 'ItemList',
        '@id': `${pageUrl}#tool-list`,
        name: t('help.toc_system_index'),
        itemListElement: items.map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.name,
          description: item.description,
          url: item.url,
        })),
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'kensuke-system',
            item: SITE_URL,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: t('help.title'),
            item: pageUrl,
          },
        ],
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
